<template>
    <div>
        <query-menu v-if="showMenu" :filter-info="filterOptions" :show-query-menu="showMenu && filterOptions !== null"
            @onclose="showMenu = false" @onquery="onQuery"></query-menu>
            <div class="container">
                <div class="row">
                    <div v-for="(user, index) in items" :key="user.userId || index" class="col-lg-6 col-md-6 col-sm-12">
                        <div class="panel panel-default user-panel">
                    <div class="panel-heading">
                        <h3 class="panel-title">User Information #{{ index + 1 }}</h3>
                    </div>
                    <div class="panel-body">
                        <!--ggg-->
                        <!-- Responsive two-column layout for properties -->
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <dl>
                                    <dt>Display Name</dt>
                                    <dd>{{ user.displayName }}</dd>

                                    <dt>Given Name</dt>
                                    <dd>{{ user.givenName }}</dd>

                                    <dt>Surname</dt>
                                    <dd>{{ user.surname }}</dd>

                                    <dt>Email</dt>
                                    <dd class="email-break">{{ user.email }}</dd>
                                </dl>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <dl>
                                    <dt>Email Confirmed</dt>
                                    <dd>{{ user.emailConfirmed }}</dd>

                                    <dt>Phone</dt>
                                    <dd>{{ user.phone || 'null' }}</dd>

                                    <dt>Domain Root ID</dt>
                                    <dd>{{ user.domainRootId }}</dd>

                                    <dt>Create Date</dt>
                                    <dd>{{ formatDate(user.createDate) }}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="panel-footer text-right">
                        <button type="button" class="btn btn-primary btn-sm">Select</button>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
import pagedLoading from '../components/base/PagedLoading.vue';
import queryString from '../utl/queryString';
import apis from '../api/extApi.js';
import addPost from './addPost.vue';
import modalX from '../components/base/ModalX1.vue';
import post from './sub/post.vue';
import postRow from './sub/postRow.vue';
import queryMenu from './queryMenu.vue';

export default {
    components: {
        pagedLoading: pagedLoading,
        addPost: addPost,
        modalX: modalX,
        post: post,
        postRow: postRow,
        queryMenu: queryMenu,
        postEditor: () => import('./postEditor.vue')
    },
    props: {
        "userId": String,
        "initFilter": {
            type: Object, default: null
        },
        "viewMode": {
            type: String, default: 'post'
        }
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        noRoute: function () {
            return this.initFilter !== null;
        }
    },
    data: function () {
        return {
            catCodes: apis.api.settings.catCodes,
            apiClient: apis.api,
            items: [],
            paging: { page: 1, pageSize: 1, count: 1 },
            loadingImg: false,
            categories: null,
            isAddingPost: false,
            isEditingPost: false,
            editingPostId: null,
            showMenu: false,
            filterScopes: null,
            currentQuery: null,
            filterOptions: null,
            loadedQuery: null
        };
    },
    methods: {
        // showFilterMenu: function () {
        //     if (!this.filterInfo) {
        //         this.apiClient.getShopViewModelByUidPrms(this.userId).done((ret) => {
        //             console.log('filterInfo', ret.value.filterInfo);
        //             this.filterOptions = ret.value.filterInfo;
        //             this.showMenu = true;
        //         });
        //     } else {
        //         this.filterOptions = this.filterInfo;
        //     }
        // },
        showAll: function () {
            this.onQuery({ query: null });
        },
        onQuery: function (ret) {
            console.log("onQuery obj:", ret);
            var q = ret.query === null ? {} : ret.query;
            this.filterScopes = {
                cat: q.cat,
                tag: q.tag,
                keyword: (q.keyword && q.keyword !== null) ? q.keyword : ""
            };
            var obj = {
                page: 1,                
                ...this.filterScopes
            };
            if (this.noRoute) {
                obj.uid = this.userId;
                var qs = queryString().getString(obj);
                this.loadItems(qs);
            } else {
                obj.shopUserId = this.userId;
                var newRoute = {
                    name: "PostList", query: obj
                };
                this.$router.push(newRoute);
            }
        },
        getQueryFromRoute() {
            var route = this.$router.currentRoute;
            var query = route.query;
            var newQuery = {};
            for (var n in query) {
                newQuery[n] = query[n];
            };
            return newQuery;
        },
        pageChange: function (page) {
            var newQuery = this.getQueryFromRoute();
            newQuery.page = page;
            if (this.noRoute) {
                newQuery.uid = this.userId;//add this only when loadItems as uid no need to present in url
                this.loadItems(queryString().getString(newQuery));
            } else {
                var newRoute = {
                    name: "PostList", query: newQuery
                };
                this.$router.push(newRoute);
            }
        },
        loadItems: function (query) {
            this.currentQuery = query;
            this.loadingImg = true;
            this.apiClient.usersApi.getUsersPrms(query).done((ret) => {
                this.loadingImg = false;
                var filter = ret.filter;
                this.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                this.items = ret.items;
                this.loadedQuery = query;
            }).fail(() => {
                this.loadingImg = false;
            });
        },
        getRoutePage: function () {
            var rPage = this.$route.query.page;
            if (typeof rPage === "undefined") {
                rPage = 1;
            };
            return rPage;
        },
        getQueryString: function () {
            var q = this.getQueryFromRoute();
            q.uid = this.userId;
            return queryString().getString(q);
        },
        initPaging: function () {
            this.loadItems(this.getQueryString());
        },
        formatDate: function (dateStr) {
            if (!dateStr) return '';
            var date = new Date(dateStr);
            var year = date.getFullYear();
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            var hours = ('0' + date.getHours()).slice(-2);
            var minutes = ('0' + date.getMinutes()).slice(-2);
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes;
        }
    },
    watch: {
        '$route'(to, from) {
            if (this.noRoute) return;
            if (to.name === 'PostList') {
                console.log("handling route change", this.$route.query);
                this.page = this.getRoutePage();
                var qstr = this.getQueryString();
                console.log('loadedQuery:', this.loadedQuery, ',current query:', qstr, ',', this.loadedQuery === qstr);
                if (qstr === this.loadedQuery) {
                    return;
                }
                this.loadItems(qstr);
            }
        }
    },
    mounted: function () {
        this.initPaging();
    },
    activated: function () {
        console.log("postlist activated!!!!!!");
        //this.reload();
        var q = this.getQueryString();
        this.loadItems(q);
    },
    deactivated: function () {
        console.log("postlist deactivated!!!!!");
    }
}
</script>

<style scoped>
/* Panel styling - Enhanced with elegant shadows and borders */
.user-panel {
    margin-bottom: 30px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.user-panel:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.panel-heading {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 15px 20px;
    border-bottom: none;
}

.panel-heading h3.panel-title {
    margin: 0;
    font-size: 18px;
    color: #ffffff;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.panel-body {
    padding: 25px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fafbfc;
}

.panel-body dl {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin: 0;
    padding-left: 10px;
    padding-right: 10px;
}

.panel-body dt {
    text-align: left;
    font-weight: 600;
    color: #5a6c7d;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    padding: 8px 12px;
    border-radius: 4px;
    width: 100%;
    margin-top: 8px;
    background-color: transparent;
    border-left: 3px solid #667eea;
}

.panel-body dt:first-child {
    margin-top: 0;
}

.panel-body dd {
    text-align: left;
    margin-left: 0;
    border: 1px solid #e1e8ed;
    padding: 12px 15px;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 12px;
    background-color: #ffffff;
    color: #2c3e50;
    font-size: 14px;
    line-height: 1.5;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.panel-body dd:hover {
    border-color: #667eea;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
}

/* Large screen optimization - vertical label/value layout */
@media (min-width: 992px) {
    .panel-body dl {
        display: flex;
        flex-direction: column;
        padding-left: 15px;
        padding-right: 15px;
    }
    
    .panel-body dt {
        text-align: left;
        padding: 8px 12px;
        font-weight: 600;
        background-color: transparent;
        border-radius: 4px;
        height: auto;
        box-sizing: border-box;
        border-left: 3px solid #667eea;
        border-right: none;
        color: #5a6c7d;
        width: 100%;
        margin-top: 8px;
    }
    
    .panel-body dt:first-child {
        margin-top: 0;
    }
    
    .panel-body dd {
        text-align: left;
        margin-bottom: 12px;
        padding: 12px 15px;
        border: 1px solid #e1e8ed;
        border-radius: 6px;
        height: auto;
        box-sizing: border-box;
        width: 100%;
        margin-left: 0;
    }
}
/* Medium screen - stretch labels and values container to fill parent width */
@media (min-width: 768px) and (max-width: 991px) {
    .panel-body dl {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
    
    .panel-body dt,
    .panel-body dd {
        width: 100%;
        box-sizing: border-box;
        height: 50px;
        display: flex;
        align-items: center;
    }
}
/* Medium screen - stretch labels and values container to fill parent width */

.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    align-items: stretch;
}

.row > [class*="col-"] {
    display: flex;
    flex-direction: column;
}

/* Compact roles list */
.roles-list {
    margin-top: 10px;
    padding-left: 20px;
}

.roles-list .list-group-item {
    border: none;
    padding: 5px 10px;
    background: transparent;
}

/* Responsive tweaks */
@media (max-width: 768px) {
    .panel-heading h3.panel-title {
        font-size: 16px;
    }

    .panel-body dt {
        float: none;
        width: auto;
        text-align: left;
        margin-bottom: 5px;
        height: 50px;
        display: flex;
        align-items: center;
    }

    .panel-body dd {
        margin-left: 0;
        text-align: left;
        overflow-wrap: break-word;
        height: 50px;
        display: flex;
        align-items: center;
    }
}
.email-break {
    word-break: break-all;
    overflow-wrap: break-word;
    max-width: 100%;
}

@media (max-width: 480px) {
    .panel-body dt,
    .panel-body dd {
        font-size: 13px;
    }
    
    .panel-heading {
        padding: 12px 15px;
    }
    
    .panel-body {
        padding: 15px 12px;
    }
}

.panel-footer {
    display: flex;
    justify-content: flex-end;
    padding: 15px 20px;
    width: 100%;
    background-color: #f8f9fa;
    border-top: 1px solid #e8e8e8;
}

.panel-footer .btn {
    border-radius: 4px;
    font-weight: 500;
    padding: 8px 20px;
    transition: all 0.2s ease;
}

.panel-footer .btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
}
</style>
